import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { EmploymentHistoryService } from './employment-history.service';

const service = new EmploymentHistoryService();

export interface EmploymentHistoryState {}

const EmploymentHistoryStore: Module<EmploymentHistoryState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async addEmploymentHistory(context: any, employmentHistory: any) {
         return await service.postEmploymentHistory(employmentHistory);
      },
   },
};

export default EmploymentHistoryStore;
